import { render, staticRenderFns } from "./DashboardIndexLeftMenu.vue?vue&type=template&id=232276b7&scoped=true&"
import script from "./DashboardIndexLeftMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardIndexLeftMenu.vue?vue&type=script&lang=js&"
import style0 from "./DashboardIndexLeftMenu.vue?vue&type=style&index=0&id=232276b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232276b7",
  null
  
)

export default component.exports